module.exports = __webpack_public_path__ + "img/bb_platform_03.bf373eb1.svg";